<template>
  <div>
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="分类">
          <el-select v-model="formInline.category_id" placeholder="请选择" clearable>
            <el-option label="不限" value=""></el-option>
            <el-option v-for="(item, index) in category" :key="index" :label="item.name" :value="item.category_id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否收费">
          <el-select v-model="formInline.is_money" placeholder="请选择" clearable>
            <el-option label="不限" value=""></el-option>
            <el-option label="收费" value="1"></el-option>
            <el-option label="免费" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="formInline.is_money" placeholder="请选择" clearable>
            <el-option label="不限" value=""></el-option>
            <el-option label="显示" value="1"></el-option>
            <el-option label="隐藏" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item><el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button></el-form-item>
      </el-form>
    </div>
    <div class="common-level-rail">
      <el-button size="small" type="primary" icon="el-icon-plus" @click="addFun">添加</el-button>
      <el-button size="small" type="primary" @click="openPopup('batch')" icon="el-icon-check">批量操作</el-button>
    </div>
    <div class="table-wrap">
      <el-table :data="tableData" ref="dragTable" style="width: 100%" v-loading="loading" :row-key="getRowKey"  @selection-change="tableCurrentChange">
        <el-table-column type="selection" :reserve-selection="true" align="center" width="45"></el-table-column>
        <el-table-column prop="course_id" label="课程ID" width="60"></el-table-column>
        <el-table-column prop="address" label="封面" width="50">
          <template slot-scope="scope">
            <img v-if="scope.row.image && scope.row.image.file_path" :src="scope.row.image.file_path" width="30" height="30" />
          </template>
        </el-table-column>
        <el-table-column prop="title" label="标题">
          <template slot-scope="scope">
            <div class="text-ellipsis" :title="scope.row.title">{{scope.row.title}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="category.name" label="分类" width="120"></el-table-column>
        <el-table-column prop="status" label="是否收费" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.is_money == 0" class="gray9">免费</span>
            <span v-if="scope.row.is_money == 1" class="red">收费</span>
          </template>
        </el-table-column>
        <el-table-column prop="virtual_views" label="实际阅读量" width="100"></el-table-column>
        <el-table-column prop="sort" label="排序" width="100"></el-table-column>
        <el-table-column prop="status" label="状态" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 1" class="green">显示</span>
            <span v-if="scope.row.status == 0" class="gray">隐藏</span>
          </template>
        </el-table-column>
        <el-table-column prop="create_time" label="添加时间" width="140"></el-table-column>
        <el-table-column prop="update_time" label="更新时间" width="140"></el-table-column>
        <el-table-column prop="name" label="操作" width="90" fixed="right">
          <template slot-scope="scope">
            <el-button @click="editFun(scope.row)" type="text" size="small">编辑</el-button>
            <el-button @click="deleteFun(scope.row)" type="text" size="small">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!--分页-->
      <div class="pagination">
        <el-pagination background :current-page="curPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="totalDataNumber"></el-pagination>
      </div>
    </div>

    <!--批量-->
    <Batch v-if="show_popup['batch']" :is_open="show_popup['batch']" :category="category" :ids="ids" @closeDialog="closeDialogFunc($event, 'batch')"></Batch>
  </div>
</template>

<script>
import CourseApi from '@/api/study/course.js';
import Batch from './Batch';
export default {
  components: {Batch},
  data() {
    return {
      /*分类*/
      category: [],
      /*表单数据*/
      tableData: [],
      /*是否打开添加弹窗*/
      /*当前编辑的对象*/
      userModel: {},
      /*横向表单数据模型*/
      formInline: {
        category_id: '',
        is_money: '',
        status: '',
      },
      commentData: [],
      loading: true,
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*弹窗*/
      show_popup: {
        batch: false,
      },
      /*批量操作*/
      multipleSelection: [],
      ids: [],
    };
  },
  created() {
    /*获取列表*/
    this.getTableList();
  },
  methods: {
    // 保存选中的数据id,row-key就是要指定一个key标识这一行的数据
    getRowKey (row) {
      return row.course_id;
    },
    /*监听复选按钮选中事件*/
    tableCurrentChange(val) {
      this.multipleSelection = val;
      this.ids = [];
      val.forEach(e => {
        this.ids.push(e.course_id);
      });
    },
    /*获取列表*/
    getTableList() {
      let self = this;
      let Params = self.formInline;
      Params.page = self.curPage;
      CourseApi.getList(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.category = data.data.catgory;
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*添加*/
    addFun() {
      this.$router.push({
        path: '/study/course/add'
      });
    },

    /*编辑*/
    editFun(row) {
      let params = row.course_id;
      this.$router.push({
        path: '/study/course/edit',
        query: {
          course_id: params
        }
      });
    },

    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.loading = true;
      self.getData();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.getData();
    },

    /*删除分类*/
    deleteFun(row) {
      let self = this;
      self
        .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          CourseApi.del(
            {
              course_id: row.course_id
            },
            true
          )
            .then(data => {
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.getTableList();
            })
            .catch(error => {});
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },

    /*搜索查询*/
    onSubmit() {
      let self = this;
      self.loading = true;
      self.getTableList();
      this.ids = [];
      this.$refs.dragTable.clearSelection();
    },

    /*打开弹窗*/
    openPopup(name, item){
      this.show_popup[name] = true;
      if (item) this.selectModel = item;
    },

    /*关闭弹窗*/
    closeDialogFunc(e, f) {
      this.show_popup[f] = e.openDialog;
      if (e.type == 'success') {
        this.getTableList();
      }
    },

  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/study/course/index.vue